import { useEffect, useState } from 'react';
import { OnboardingEye } from '../Eye';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from './OnboardingSequence';
import InputBar from '../InputBar';
import useOnboardingStore from 'stores/onboardingStore';
import BPContainer from 'components/BionicUI/container/BPContainer';
import BPButton from 'components/BionicUI/button/BPButton';
import BPInput from 'components/BionicUI/input/BPInput';
// import BPLinkButton from 'components/BionicUI/linkButton/BPLinkButton';
// import { useAuth } from 'context/auth.context';
// import { AdditionalUserInfo } from 'firebase/auth';
// import { PostUserSocialRequest } from 'core/models/users/socials/post-user-social.model';
// import { SocialNetworkType } from 'core/models/users/socials/user-social.model';
// import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
// import { FirebaseError } from 'firebase/app';
// import useNotifyStore from 'stores/notifyStore';
// import BPToast from 'components/BionicUI/toast/BPToast';
import { useLinkAccount, usePrivy } from '@privy-io/react-auth';
import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';

const LogInWithX = () => {
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const [showXDetails, setShowXDetails] = useState<boolean>(false);
  const { nextStep, setProgressStep } = useOnboardingStore();
  // const [additionalUserInfo, setAdditionalUserInfo] =
  //   useState<AdditionalUserInfo | null>(null);
  const { user } = usePrivy();
  // const { setCurrentToast } = useNotifyStore();
  const { linkTwitter } = useLinkAccount();

  async function onLinkToX() {
    // console.log(object)
    localStorage.setItem('currentStep', JSON.stringify(4));
    const res = linkTwitter();
    console.log('res--', res);
    // .then(async (result) => {
    //     const request: PostUserSocialRequest = {
    //       socialNetwork: SocialNetworkType.TWITTER,
    //       url: 'https://twitter.com/' + result.username!,
    //       username: result.username!,
    //     };
    //     if (result) {
    //       await new UserV1BaseServerRepo().createSocials(request);
    //       setAdditionalUserInfo(result);
    //       setShowXDetails(true);
    //     }
    //   })
    //   .catch((error) => {
    //     let errMsg = 'Try Again Later.';
    //     if (
    //       (error as FirebaseError).code === 'auth/credential-already-in-use'
    //     ) {
    //       errMsg = 'Twitter account is already linked with another user.';
    //     }
    // setCurrentToast(<BPToast message={errMsg} variant="error" />);
    // });
  }

  async function createXAccount() {
    try {
      await new UserV1BaseServerRepo().createTwitter({});
    } catch (error) {
      console.log('Error:--', error);
    }
  }

  useEffect(() => {
    if (user?.twitter) {
      const isFromIntro = localStorage.getItem('fromIntro');
      createXAccount();
      if (isFromIntro && JSON.parse(isFromIntro)) {
        nextStep();
        localStorage.removeItem('fromIntro');
      } else {
        setShowXDetails(true);
      }
    }
  }, [user]);

  useEffect(() => {
    setTimeout(() => setShowInputBar(true), 350);
  });

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: 'Please connect your X.com account. This is just to verify your ownership of the account.',
            sound: 'step1/please-connect-x-dot-com.mp3',
          }}
        >
          {showXDetails && (
            <div className="grid gap-4 text-[14px] font-medium">
              <div className="text-bionic-muted">
                This will help us to verify your identity and validate ownership
                of the account.
              </div>
              <div className="grid gap-1">
                <div className="pt-3 pb-0 pointer-events-none">
                  <BPInput
                    state="success"
                    value={'@' + user?.twitter?.username}
                  />
                </div>
                {/* <div>
                  <BPLinkButton className="text-[12px]">
                    Disconnect account
                  </BPLinkButton>
                </div> */}
              </div>
              {/* <div>Want to change your X.com account?</div>
              <div className="text-bionic-muted">
                If you have connected to the wrong X.com account, first make
                sure you are logged in to the correct account in your browser
                and then try again.
              </div> */}
            </div>
          )}
        </BPInstruction>
      </div>
      {showInputBar && (
        <InputBar onClickBackButton={() => setProgressStep(3)}>
          <BPContainer twWidth="w-auto md:w-[644px] justify-normal">
            {showXDetails ? (
              <BPButton state="primary" onClick={nextStep}>
                Next
              </BPButton>
            ) : (
              <BPButton state="primary" onClick={onLinkToX}>
                Log in with X.com
              </BPButton>
            )}
          </BPContainer>
        </InputBar>
      )}
    </SequenceItem>
  );
};

export default LogInWithX;
